import mappingFields from '@/domain/data/installation/engineering/waterOnPaper/mappingFields';

const parametersFields = {
  equilibriumCurve: {
    label: mappingFields.CurvaEquilibrio,
    required: true,
  },
  gasVolume: {
    label: mappingFields.VolumeGas,
    required: true,
    maxLength: 6,
    precision: 2,
    default: 1,
    minValue: 0.01,
    maxValue: 100,
  },
  shouldConsiderStabilizationTime: {
    label: mappingFields.DeveConsiderarTempoEstabilizacao,
    required: true,
  },
  paperActivationEnergy: {
    label: mappingFields.EnergiaAtivacaoPapel,
    required: true,
    maxLength: 10,
    precision: 2,
    default: 8074,
    minValue: 0,
    maxValue: 100000,
  },
  paperThickness: {
    label: mappingFields.EspessuraPapel,
    required: true,
    maxLength: 6,
    precision: 2,
    default: 1,
    minValue: 1,
    maxValue: 100,
  },
  shouldConsiderOilType: {
    label: mappingFields.DeveConsiderarTipoOleo,
    required: true,
  },
  oilSolubilityConstant: {
    label: mappingFields.ConstanteSolubilidadeOleo,
    required: true,
    maxLength: 8,
    precision: 1,
    minValue: 1,
    maxValue: 10000,
  },
  atmosphericPressure: {
    label: mappingFields.PressaoAtmosferica,
    required: true,
    maxLength: 10,
    precision: 2,
    Default: 830,
    minValue: 0,
    maxValue: 100000,
  },
  referenceTemperature: {
    label: mappingFields.TemperaturaReferencia,
    required: true,
    maxLength: 5,
    precision: 1,
    minValue: 0.1,
    maxValue: 100,
  },
  estimatedHeightBetweenConservatorAndWindingTop: {
    label: mappingFields.AlturaEstimadaEntreConservadorTopoEnrolamento,
    required: true,
    maxLength: 5,
    precision: 2,
    default: 2.5,
    minValue: 0,
    maxValue: 10,
  },
  bubbleFormationMinimumTemperatureDifference: {
    label: mappingFields.MinimaDiferencaTemperaturaFormacaoBolha,
    required: true,
    maxLength: 2,
    precision: 0,
    default: 20,
    minValue: 10,
    maxValue: 50,
  },
  admissibleWaterOnPaper: {
    label: mappingFields.AguaPapelAdmissivel,
    required: true,
    maxLength: 5,
    precision: 2,
    default: 10,
    minValue: 0.01,
    maxValue: 99.99,
  },
};

export default parametersFields;
